export const getFormatedDate = (date, formatType) => {
  if (!date) return null;

  const d = typeof date === "string" ? new Date(date) : date;
  if (isNaN(d)) return null; // Invalid date

  const pad = (num) => (num < 10 ? "0" + num : num);

  const day = pad(d.getDate());
  const month = pad(d.getMonth() + 1);
  const year = d.getFullYear();
  const hours = pad(d.getHours());
  const minutes = pad(d.getMinutes());

  switch (formatType) {
    case "-":
      return `${year}-${month}-${day}`;
    case ".":
      return `${year}.${month}.${day}`;
    case "dd.mm.yyyy":
      return `${day}.${month}.${year}`;
    case "dd.mm.yyyy / hh:mm":
      return `${day}.${month}.${year} / ${hours}:${minutes}`;
    default:
      return null;
  }
};

